import { SelectionBox } from '@/Engine/SelectionBox';
import { RackModule } from '@/Engine/Wardrobe/RackModule';
import { SceneObjects } from '@/Interfaces/common';
import { OBB } from 'three/examples/jsm/math/OBB';

export const _checkCollision = (object: SceneObjects, objects: (SceneObjects | { obb: OBB; uuid: string; side: string })[]) => {
    let collisionFlag = false;
    let collisionObject;
    objects.forEach((module)=>{
        // if (module.stacked) return;
        // TODO не помню зачем эта проверка, надо убрать потестить
        if (module === object) return;
        collisionFlag =
            collisionFlag ||
            object.obb.intersectsOBB(module.obb) &&
            !(collisionObject = module);
    });

    return collisionObject;
};

export const _checkAllCollision = (object: SceneObjects, objects: (SceneObjects | { obb: OBB; uuid: string; side: string })[]) => {
    const collisions = [];
    objects.forEach((module)=>{
        // if (module.stacked) return;
        // TODO не помню зачем эта проверка, надо убрать потестить
        if (module === object) return;
        if (object.obb.intersectsOBB(module.obb))
            collisions.push(module);
    });

    return collisions;
};

export const checkRackCollision = (module1: RackModule, module2: RackModule, left = true) => {
    const error = 0.1;
    const point1 = module1.position.x + (+left*2 - 1) * module1.width/2;
    const point2 = module2.position.x - (+left*2 - 1) * module2.width/2;

    return Math.abs(point1 - point2) < error;
};

export const _checkGroupCollision = (selectionBox: SelectionBox,objects: Array<SceneObjects>) => {
    let collisionFlag = false;
    objects.forEach((module)=>{
        collisionFlag = collisionFlag || selectionBox.obb.intersectsOBB(module.obb);
    });

    return collisionFlag;
};
